import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { publique } from '../services/api';
import Coquille, { messagePublic } from './Coquille';

const ETAT = { accorde: ['Accordé', 'pb-tag--oui'], refuse: ['Refusé', 'pb-tag--non'], retire: ['Retiré', 'pb-tag--non'], expire: ['Expiré', 'pb-tag--autre'] };
const SOURCE = { formulaire_sms: 'formulaire reçu par SMS', formulaire_email: 'formulaire reçu par e-mail', formulaire_web: 'formulaire web', oral_appel: 'recueil oral pendant un appel', papier: 'document papier', operateur: 'enregistré par un opérateur', lien_retrait: 'lien de retrait', stop_sms: 'réponse STOP', systeme: 'automatique' };

// Preuve : restitution gratuite et intégrale de ce qui a été présenté et
// répondu, avec l'empreinte chaînée (décret 2026-662).
export default function Preuve() {
  const { token } = useParams();
  const [p, setP] = useState(null);
  const [erreur, setErreur] = useState('');
  useEffect(() => { publique.preuve(token).then((r) => setP(r.data)).catch((e) => setErreur(messagePublic(e))); }, [token]);

  if (erreur) return <Coquille><h1>Preuve introuvable</h1><div className="pb-erreur">{erreur}</div></Coquille>;
  if (!p) return <Coquille><p>Chargement…</p></Coquille>;
  const horo = new Date(p.horodatage);
  return (
    <Coquille societe={p.societe}>
      <h1>Preuve de consentement</h1>
      <dl className="pb-dl">
        <dt>Identifiant</dt><dd><span className="pb-identifiant">{p.identifiant}</span></dd>
        <dt>Horodatage</dt><dd>{horo.toLocaleString('fr-FR', { dateStyle: 'long', timeStyle: 'medium' })}</dd>
        <dt>Mode de recueil</dt><dd>{SOURCE[p.source] || p.source}</dd>
        {p.message_id && <><dt>Message d'origine</dt><dd className="pb-hash">{p.message_id}</dd></>}
      </dl>
      <ul className="pb-recap">
        {p.evenements.map((e, i) => {
          const [lib, cls] = ETAT[e.etat] || [e.etat, 'pb-tag--autre'];
          return <li key={i}><span>{e.libelle}{e.etat === 'accorde' && e.valide_jusqu_au ? <><br /><span style={{ fontSize: 12.5, color: '#5b6660' }}>valable jusqu'au {new Date(e.valide_jusqu_au).toLocaleDateString('fr-FR')}</span></> : null}</span><span className={`pb-tag ${cls}`}>{lib}</span></li>;
        })}
      </ul>
      {p.mentions?.length > 0 && (
        <>
          <p><strong>Textes présentés</strong> (version figée au moment du recueil) :</p>
          {p.mentions.map((m, i) => <div className="pb-mention-preuve" key={i}><small>{m.finalite || 'mention générale'} · version {m.version}</small>{m.texte}</div>)}
        </>
      )}
      <p className="pb-note">Empreinte SHA-256 de cette preuve, chaînée à la précédente et scellée chaque jour : toute modification ultérieure serait détectable.</p>
      <p className="pb-hash">{p.sha256}</p>
      {p.sha256_precedent && <p className="pb-hash" style={{ opacity: 0.7 }}>précédente : {p.sha256_precedent}</p>}
    </Coquille>
  );
}
